import React, { useEffect, useState } from "react";
import Place from "@/assets/place.png";
import Guide from "@/assets/guide.png";
import "./welcome.scss";
import { PageHeader } from "@/components/header/header";
import { useHistory } from "react-router-dom";
import { formatDay, formatTime } from "@/utils/helper";
import Footer from "../Footer/Footer";
import useSocket from "@/hooks/useSocket";
import { ESocketEvents } from "@/utils/api/sockets.enum";
import WaitingRoom from "../WaitingRoom/Waitingroom";
import { toast } from "react-toastify";
import WelcomeLoader from "../WelcomeLoader/WelcomeLoader";
import { eventRoomStore } from "../../stores/event";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { globalStore } from "@/stores/global";
import MapContainer from "@/components/MapContainer";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
import HomeIcon from "@mui/icons-material/Home";
import PermContactCalendarIcon from "@mui/icons-material/PermContactCalendar";

const Welcome = (props: any) => {
  globalStore.stopLoading();
  const { addSocketEvent, initializeSocket, emitEvent } = useSocket();
  const history = useHistory();
  const eventDetail = props?.visit as any;
  const visit = props?.visit_id;
  const eventid = eventDetail?.id;
  const user_type = eventDetail?.user_role;
  const [visitEnabled, setVisitEnabled] = useState(
    eventDetail?.visit_started ? eventDetail?.visit_started : false
  );
  const [isLoading, setIsLoading] = useState(false);
  const [isWaiting, setwaiting] = useState(false);
  const [isRequestingPermissions, setIsRequestingPermissions] = useState(false);

  /**
   * Demande les permissions caméra/micro au navigateur.
   * Doit être appelé directement depuis un événement utilisateur (clic)
   * pour fonctionner sur iOS Safari/Chrome.
   */
  const requestMediaPermissions = async (): Promise<boolean> => {
    // Vérifier si l'API est disponible
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      console.warn("getUserMedia not supported");
      return true; // Continuer quand même (peut-être une ancienne version)
    }

    try {
      setIsRequestingPermissions(true);
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: true
      });
      // Arrêter les tracks immédiatement (on veut juste la permission)
      stream.getTracks().forEach(track => track.stop());
      console.log("Media permissions granted");
      return true;
    } catch (error: any) {
      console.error("Media permission error:", error);

      if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
        toast.error(
          "Veuillez autoriser l'accès à la caméra et au microphone pour rejoindre la visite.",
          { autoClose: 10000 }
        );
      } else if (error.name === 'NotFoundError' || error.name === 'DevicesNotFoundError') {
        toast.error(
          "Aucune caméra ou microphone détecté. Veuillez vérifier vos appareils.",
          { autoClose: 10000 }
        );
      } else {
        toast.error(
          "Erreur lors de l'accès à la caméra/microphone. Veuillez réessayer.",
          { autoClose: 10000 }
        );
      }
      return false;
    } finally {
      setIsRequestingPermissions(false);
    }
  };

  const JoinHandler = async (time: any) => {
    // Demander les permissions AVANT de continuer (important pour iOS)
    const hasPermissions = await requestMediaPermissions();
    if (!hasPermissions) {
      return; // Ne pas continuer si les permissions sont refusées
    }

    if (user_type == "host") {
      if (eventRoomStore.canStartVisit(time)) {
        history.push(`/meeting/${visit}`);
      } else {
        toast.error("Vous n'êtes pas autorisé à rejoindre avant 20 minutes", {
          autoClose: 8000,
        });
      }
    } else {
      if (eventRoomStore.canStartVisit(time)) {
        setwaiting(true);
        setTimeout(() => {
          history.push(`/meeting/${visit}`);
        }, 5000);
      } else {
        toast.error(
          "Votre voyage culturel n'a pas encore commencé. Veuillez actualiser la page plus tard.",
          {
            autoClose: 8000
          }
        );
      }
    }
  };

  useEffect(() => {
    if(user_type === 'residence' || user_type === 'multiconnection' || user_type === 'invitee') {
      eventRoomStore.hasVisitStarted(false);
      sessionStorage.clear();
    }
  }, [user_type])

  // const JoinHandler = (time: any) => {
  //   if (user_type == "host") {
  //     if (eventRoomStore.canStartVisit(time)) {
  //       history.push(`/meeting/${visit}`);
  //     } else {
  //       toast.error("Vous n'êtes pas autorisé à rejoindre avant 20 minutes");
  //     }
  //   } else {
  //       setwaiting(true);
  //       setTimeout(() => {
  //         history.push(`/meeting/${visit}`);
  //       }, 5000);
  //   }
  // };

  const ImageHandler = (link: any) => {
    let text = link;
    text = text.replace("file/d/", "uc?id=");
    text = text.split("/view?usp=");
    return text[0];
  };

  useEffect(() => {
    //VisitDetails(eventid);
    initializeSocket();
    emitEvent(ESocketEvents.JoinVisit, {
      visit_id: eventid,
      user_role: user_type,
    });
    addSocketEvent(ESocketEvents.StartVisit, (visitId) => {
      if (eventid == visitId) {
        !visitEnabled ? setVisitEnabled(true) : null;
      }
    });
  }, []);

  const residenceLat = eventDetail.residence_latitude;
  const residenceLng = eventDetail.residence_longitude;

  // Gurgaon Coordinates
  const guideLat = eventDetail.guide_latitude;
  const guideLng = eventDetail.guide_longitude;

  const filteredParticipants = eventDetail.participants.filter(
    (participant: any) => participant.user_role === "MultiConnection"
  );

  const filteredResidence = eventDetail.participants.filter(
    (participant: any) => participant.user_role === "Residence"
  );

  const filteredInvitee = eventDetail.participants.filter(
    (participant: any) => participant.user_role === "Invitee"
  );

  // Clé unique pour identifier cette session de visite
  const sessionKey = `tm_visit_session_${eventid}_${user_type}`;

  useEffect(() => {
    // Vérifier si c'est une reconnexion (même session/onglet)
    const existingSession = sessionStorage.getItem(sessionKey);
    
    filteredInvitee.forEach((invitee:any) => {
      if (invitee.status === "JOINED" && invitee.link === window.location.href) {
        // Si c'est la même session, permettre la reconnexion
        if (existingSession) {
          console.log("Reconnexion détectée pour invitee - même session");
          return;
        }
        // Sinon, c'est une tentative de double connexion depuis un autre appareil
        window.location.href = '/404';
      }
    });
    
    // Marquer cette session comme active
    sessionStorage.setItem(sessionKey, Date.now().toString());
  }, [filteredInvitee, sessionKey]);

  console.log(filteredResidence, eventDetail, 'filteredResidence');

  useEffect(() => {
    if(user_type === 'residence') {
      // Vérifier si c'est une reconnexion (même session/onglet)
      const existingSession = sessionStorage.getItem(sessionKey);
      
      if (filteredResidence[0]?.status === "JOINED" && user_type === 'residence') {
        // Si c'est la même session, permettre la reconnexion
        if (existingSession) {
          console.log("Reconnexion détectée pour résidence - même session");
          return;
        }
        // Sinon, c'est une tentative de double connexion depuis un autre appareil
        window.location.href = '/404';
      }
      
      // Marquer cette session comme active
      sessionStorage.setItem(sessionKey, Date.now().toString());
    }
  }, [filteredResidence, user_type, sessionKey]);

  return (
    <>
      {isWaiting ? (
        <WaitingRoom />
      ) : (
        <div className="welcome">
          <PageHeader
            user_type={user_type}
            ShowOffer={true}
            Showcontact={true}
          />
          <div
            className={
              user_type === "residence" ? "welcome-page" : "welcome-page-host"
            }
          >
            {isLoading ? (
              <WelcomeLoader />
            ) : (
              <>
                <div className="page-container">
                  <div className="page-main">
                    <div
                      className={
                        user_type === "residence" || user_type === "multiconnection"
                          ? "page-left-side"
                          : "page-left-side-host"
                      }
                    >
                      <img
                        src={
                          eventDetail?.visit_picture &&
                          eventDetail?.visit_picture.includes("http")
                            ? ImageHandler(eventDetail.visit_picture)
                            : Place
                        }
                      />
                    </div>
                    {user_type === "residence" && (
                      <MapContainer
                        coordinates={{
                          residence: { lat: residenceLat, lng: residenceLng },
                          guide: { lat: guideLat, lng: guideLng },
                        }}
                        eventDetail={eventDetail}
                      />
                    )}
                    {user_type === "multiconnection" && (
                      <MapContainer
                        coordinates={{
                          residence: { lat: residenceLat, lng: residenceLng },
                          guide: { lat: guideLat, lng: guideLng },
                        }}
                        eventDetail={eventDetail}
                      />
                    )}
                  </div>
                  <div className="page-main-right">
                    <div className="page-main-right-container">
                      <div className="welcome-header">
                        {user_type === "host" ? (
                          <div className="welcome-header-text">
                            Voyage culturel
                          </div>
                        ) : (
                          <div className="welcome-header-text">
                            Votre voyage culturel
                          </div>
                        )}
                        <p className="welcome-placename">
                          {eventDetail.visit_name}
                        </p>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 15,
                          }}
                        >
                          <div className="avatar">
                            <img
                              src={
                                eventDetail?.guide_picture &&
                                eventDetail?.guide_picture.includes("http")
                                  ? ImageHandler(eventDetail.guide_picture)
                                  : Guide
                              }
                              alt="Avatar"
                              className="avatar-image"
                            />
                          </div>
                          <span
                            style={{
                              fontSize: "1.2rem",
                              color: "#1E2028",
                            }}
                          >
                            {eventDetail?.guide_name}
                          </span>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div className="welcome-resident-block">
                          <span className="welcome-resident-text">
                            <span className="welcome-resident-icon">
                              {user_type == "host" ? (
                                <PermContactCalendarIcon />
                              ) : (
                                <HomeIcon />
                              )}
                            </span>
                            {user_type === "host"
                              ? "Host"
                              : user_type === "residence"
                              ? "Residence"
                              : user_type === "invitee"
                              ? "Invité"
                              : user_type === "admin"
                              ? "Admin"
                              : user_type}
                          </span>
                          <p className="welcome-resident">
                            {user_type == "residence"
                              ? eventDetail.residence_name
                              : user_type == "host"
                              ? eventDetail.host_name
                              : user_type == "invitee"
                              ? eventDetail.invitee.name
                              : user_type == "admin"
                              ? eventDetail.admin_name
                              : filteredParticipants[0]?.user_name}
                          </p>
                        </div>
                        {user_type == "host" && (
                          <div className="welcome-resident-block">
                            <span className="welcome-resident-text">
                              <span className="welcome-resident-icon">
                                <HomeIcon />
                              </span>
                              {user_type === "host" && "Residence"}
                            </span>
                            <p className="welcome-resident">
                              {user_type == "host"
                                ? eventDetail.residence_name
                                : ""}
                              {eventDetail.new_visit_level && (
                                <span className="guide-welcome-content-header-new">
                                  {eventDetail.new_visit_level}
                                </span>
                              )}
                            </p>
                          </div>
                        )}
                      </div>
                      <div className="welcome-prescreen-date">
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                            fontSize: "1.125rem",
                            color: "#1E2028",
                          }}
                        >
                          <CalendarMonthIcon />
                          {formatDay(
                            eventRoomStore.convertTimeFromUTC(eventDetail.time)
                          )}
                        </span>
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                            fontSize: "1.125rem",
                            color: "#1E2028",
                          }}
                        >
                          <WatchLaterIcon />
                          {formatTime(
                            eventRoomStore.convertTimeFromUTC(
                              eventDetail.time_in_utc
                            )
                          )}
                        </span>
                      </div>
                      {(user_type === "guide" || user_type === "Guide") && eventDetail.comments && (
                        <div style={{ 
                          marginTop: "1rem", 
                          marginBottom: "1rem", 
                          padding: "15px", 
                          backgroundColor: "#fff3cd", 
                          border: "1px solid #ffeeba", 
                          borderRadius: "8px",
                          color: "#856404"
                        }}>
                          <p style={{ fontWeight: "bold", fontSize: "1rem", marginBottom: "5px", display: "flex", alignItems: "center", gap: "8px" }}>
                            <span style={{ fontSize: "1.2em" }}>⚠️</span> Info Visite :
                          </p>
                          <p style={{ fontSize: "0.95rem", whiteSpace: "pre-wrap" }}>
                            {eventDetail.comments}
                          </p>
                        </div>
                      )}
                      <button
                        onClick={() => {
                          JoinHandler(eventDetail.time_in_utc);
                        }}
                        className="welcome-button"
                        disabled={isRequestingPermissions}
                      >
                        {isRequestingPermissions ? (
                          "Autorisation en cours..."
                        ) : (
                          <>
                            Démarrez la visite
                            <KeyboardArrowRightIcon />
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </div>

                {/* <div className="welcome-header">
                  <div className="welcome-header-text">Votre Vonage</div>
                  <p className="welcome-placename">{eventDetail.visit_name}</p>
                </div>
                <div className="welcome-content">
                  <div className="welcome-prescreen-absolute">
                    <div className="welcome-prescreen">
                      <div className="welcome-image">
                        <div className="welcome-image-name">
                          {eventDetail.guide_name}
                        </div>
                        <div className="welcome-image-place">
                          <img
                            src={
                              eventDetail?.visit_picture &&
                              eventDetail?.visit_picture.includes("http")
                                ? ImageHandler(eventDetail.visit_picture)
                                : Place
                            }
                          />
                        </div>
                        <div className="avatar">
                          <img
                            src={
                              eventDetail?.guide_picture &&
                              eventDetail?.guide_picture.includes("http")
                                ? ImageHandler(eventDetail.guide_picture)
                                : Guide
                            }
                            alt="Avatar"
                            className="avatar-image"
                          />
                        </div>
                        {user_type === 'residence' &&
                          <MapContainer
                            coordinates={{
                              residence: { lat: residenceLat, lng: residenceLng },
                              guide: { lat: guideLat, lng: guideLng },
                            }}
                          />
                        }
                      </div>
                      <div>
                        <span className="welcome-resident-text">Residence</span>
                        <p className="welcome-resident">
                          {user_type == "residence"
                            ? eventDetail.residence_name
                            : eventDetail.host_name}
                        </p>
                        <div className="welcome-prescreen-date">
                          <p>
                            {formatDay(
                              eventRoomStore.convertTimeFromUTC(
                                eventDetail.time
                              )
                            )}
                          </p>
                          <p>
                            {formatTime(
                              eventRoomStore.convertTimeFromUTC(
                                eventDetail.time_in_utc
                              )
                            )}
                          </p>
                        </div>
                        <button
                          onClick={() => {
                            JoinHandler(eventDetail.time_in_utc);
                          }}
                          className="welcome-button"
                          // disabled={!visitEnabled}
                        >
                          Démarrez la visite
                          <KeyboardArrowRightIcon />
                        </button>
                      </div>
                    </div>
                  </div>
                </div> */}
              </>
            )}
          </div>
          <Footer />
        </div>
      )}
    </>
  );
};
export default Welcome;
